export default "__VITE_ASSET__ZwaheYSN__"